export type AgTechClassNames = string | undefined | (string | undefined)[] | AgTechClassNames[];

export const combineClassNames = (...classes: (string | (string | undefined)[] | AgTechClassNames[] | undefined | false | null)[]) => {
    const flatClasses = classes.flat();

    return flatClasses.filter(Boolean).join(' ');
  };